/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Left_TitleInputs */

const en_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Center Left`)
};

const fr_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : Au Centre a Gauche`)
};

const de_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Mitte links`)
};

const it_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: Centro-sinistra`)
};

const ru_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Левый центр`)
};

const es_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Centro Izquierda`)
};

const zh_cn2_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：左中`)
};

const ja_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポジション: 中央左`)
};

const hi_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति: केंद्र बाएँ`)
};

const pt_pt2_position_center_left_title = /** @type {(inputs: Position_Center_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Centro Esquerdo`)
};

/**
* | output |
* | --- |
* | "Position: Center Left" |
*
* @param {Position_Center_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_left_title = /** @type {((inputs?: Position_Center_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_center_left_title(inputs)
	if (locale === "de") return de_position_center_left_title(inputs)
	if (locale === "it") return it_position_center_left_title(inputs)
	if (locale === "ru") return ru_position_center_left_title(inputs)
	if (locale === "es") return es_position_center_left_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_center_left_title(inputs)
	if (locale === "ja") return ja_position_center_left_title(inputs)
	if (locale === "hi") return hi_position_center_left_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_center_left_title(inputs)
	return en_position_center_left_title(inputs)
});